import React from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "./errorPages/404";
import HomePage from "./Home";
import Authenticate from "./Authntication";
import CustomerList from "./customerList";
import ItemsCatalog from "./ItemsCatalog";
import AccountBalance from "./AccountBalance";
import Request from "./Request";
import Payment from "./payment";
import Customers from "./Customers";
import SalesAnalysis from "./SalesAnalysis";
import Settings from "./Settings";
import RequestHistory from "./RequestHistory";
import AddCustomer from "./NewCustomer";
import CustomerLocation from "./Map/CustommerLocation";
import Maketerlocation from "./Map/MaketerLocation";


const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route path={`${match.url}salesAnalysis`} component={SalesAnalysis} />
        <Route path={`${match.url}accountBalance`} component={AccountBalance} />
        <Route path={`${match.url}customerList`} component={CustomerList} />
        <Route path={`${match.url}CustomerLocation`} component={CustomerLocation} />
        <Route path={`${match.url}Maketerlocation`} component={Maketerlocation} />
        <Route path={`${match.url}request`} component={Request} />
        <Route path={`${match.url}payment`} component={Payment} />
        <Route path={`${match.url}customers`} component={Customers} />
        <Route path={`${match.url}itemsCatalog`} component={ItemsCatalog} />
        <Route path={`${match.url}settings`} component={Settings} />
        <Route path={`${match.url}home`} component={HomePage} />
        <Route path={`${match.url}authenticate`} component={Authenticate} />
        <Route path={`${match.url}requestHistory`} component={RequestHistory} />
        <Route path={`${match.url}addCustomer`} component={AddCustomer} />
        <Route path={`${match.url}*`} component={Error404} />
        <Route path={`${match.url}*/*/*`} component={Error404} />
      </Switch>
    </div>
  );
};

export default App;
